import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "cfbdb163-fdbf-4e2c-b1b4-93efd20543ba", content: "Plane 1", options: {} },
  { id: "1524daeb-bcb6-48d0-af51-79b26edd61c5", content: "Plane 2", options: {} },
  { id: "77d993a3-9ef7-4771-b5a1-67180c2f40bd", content: "Φ", options: {} },
  { id: "a79fb8bf-9584-418b-af1e-7bab8fa31807", content: "θ", options: {} },
];

const groups = [
  { id: "c3e04126-d6a8-45d0-af7b-4981b1488978", content: "Elevation angle", options: {} },
  { id: "b0814c69-1e0a-49dc-a893-3144251e455f", content: "Azimuth angle", options: {} },
  { id: "bd9a9d6b-5729-456d-9f1f-423c745f9182", content: "Horizontal Plane", options: {} },
  { id: "9a328d6f-9d7f-4060-be0a-ec877a6acb5c", content: "Median Plane", options: {} },
];

export const task: Task = {
  id: "75e52e35-e129-457c-b450-def964396f82",
  solutionType: "group",
  type: "connectWithLine",
  options: {
    shuffle: true,
    multipleConnection: false,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    { groupId: "c3e04126-d6a8-45d0-af7b-4981b1488978", itemsId: ["77d993a3-9ef7-4771-b5a1-67180c2f40bd"] },
    { groupId: "b0814c69-1e0a-49dc-a893-3144251e455f", itemsId: ["a79fb8bf-9584-418b-af1e-7bab8fa31807"] },
    { groupId: "bd9a9d6b-5729-456d-9f1f-423c745f9182", itemsId: ["1524daeb-bcb6-48d0-af51-79b26edd61c5"] },
    { groupId: "9a328d6f-9d7f-4060-be0a-ec877a6acb5c", itemsId: ["cfbdb163-fdbf-4e2c-b1b4-93efd20543ba"] },
  ],
};
